export default "__VITE_PUBLIC_ASSET__70851290__"